<template>
  <div class="h5-pc-wrapper">
    <p class="tip">新建裂变活动需要到电脑端进行设置，请用<br/>电脑访问下列链接，并按提示完成相关设置</p>
    <section class="copy">
      <p class="link">{{shortUrl}}</p>
    </section>
  </div>
</template>

<script>
import Notes from '@/engine/Notes'

export default {
  name: 'h5Pc',
  components: {
  },
  data () {
    return {
      shortUrl: '',
    }
  },
  mounted () {
    const url = `${process.env.VUE_APP_FRONTEND_DOMAIN}/?openId=${this.globalData.openId}&appId=${this.globalData.appId}`
    Notes.getShorten(url).then(({ url }) => {
      this.shortUrl = url
    })
  },
};
</script>

<style lang="scss">
.h5-pc-wrapper {
  .tip {
    margin: 0;
    padding: 200px 20px 50px;
    font-size: 14px;
    color: #e51c23;
    text-align: center;
    background-image: url('../../../assets/h5/pc.png');
    background-repeat: no-repeat;
    background-size: 180px auto;
    background-position: center 20px;
  }

  .link {
    margin: 0;
    padding: 0;
    font-size: 20px;
    text-align: center;
    color: #e51c23;
    word-break: break-all;
  }
}
</style>
